import { SectionHeadingContainer } from '@/components/SectionHeadingContainer';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
// Vite がビルド時にハッシュ付き URL に解決する
import presidentPortrait from '@/img/president.jpg';

export default function MessageSection() {
  const ref = useScrollAnimation();

  return (
    <section
      id="message"
      ref={ref}
      className="relative w-full overflow-hidden"
      style={{ backgroundColor: '#F5F2EB', paddingTop: '65px', paddingBottom: '130px' }}
      aria-label="代表メッセージ"
    >
      {/* 装飾：薄い縦ライン（セクション左端のリズム用） */}
      <div
        className="pointer-events-none absolute left-0 top-0 bottom-0 w-px opacity-40"
        style={{ background: 'linear-gradient(180deg, transparent 0%, rgba(168,205,217,0.5) 20%, rgba(168,205,217,0.5) 80%, transparent 100%)' }}
        aria-hidden={true}
      />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-8 lg:px-16">
        {/* 英字ラベル */}
        <div className="fade-in-up mb-6">
          <span
            className="section-label-en font-montserrat font-light uppercase"
            style={{ color: '#A8CDD9' }}
          >
            OUR MESSAGE
          </span>
        </div>

        {/* 見出し（本文が主役になるよう、直下には大きな写真を置かない） */}
        <SectionHeadingContainer>
          <h2
            className="section-heading fade-in-up delay-1 mb-12 text-center lg:mb-14"
            style={{
              color: '#1A1A1A',
            }}
          >
            もっと自由に、挑戦できる場所で
            <br />
            まだ見ぬ自分に会いに行こう。
          </h2>
        </SectionHeadingContainer>

        {/* 本文：狭いカラムを中央に（読みやすい1カラム） */}
        <div className="fade-in-up delay-2 mx-auto max-w-2xl">
          <div
            className="space-y-8 text-sm font-light leading-[2.35] lg:text-base"
            style={{ color: '#3A3A3A', fontFamily: "'Noto Sans JP', sans-serif", fontWeight: 300 }}
          >
            <p>
              自分の限界をきめているのは、
              <strong className="font-medium" style={{ color: '#B89B4A' }}>
                「いつも自分」
              </strong>
              可能性を広げるかどうかは、あなたの
              <strong className="font-medium" style={{ color: '#B89B4A' }}>
                選択次第
              </strong>
              です。
            </p>
            <p>
              未経験からでも段階的に成長できる環境を整えています。
            </p>
          </div>

          {/* キーメッセージ帯：左ボーダーで引用風に強調 */}
          <aside
            className="fade-in-up delay-3 mt-12 border-l-[3px] pl-6 py-1"
            style={{ borderColor: '#B89B4A' }}
          >
            <p
              className="font-serif-display italic leading-relaxed"
              style={{
                color: '#1A1A1A',
                fontSize: 'clamp(17px, 2vw, 22px)',
                fontFamily: "'Cormorant Garamond', 'Playfair Display', serif",
                fontWeight: 400,
              }}
            >
              あなたの一歩を、ここから。
            </p>
          </aside>

          {/* 署名：宣材写真は小さな円形で添える程度に抑える */}
          <div
            className="fade-in-up delay-4 mt-14 flex flex-col items-center gap-5 border-t pt-8 sm:flex-row sm:items-center sm:justify-end sm:gap-6"
            style={{ borderColor: 'rgba(168,205,217,0.45)' }}
          >
            <div className="text-center sm:text-right">
              <p
                className="text-[10px] font-light uppercase tracking-[0.25em]"
                style={{ color: '#A8CDD9', fontFamily: "'Montserrat', sans-serif" }}
              >
                Universe Inc.
              </p>
              <p className="mt-1 text-sm font-light" style={{ color: '#1A1A1A', fontFamily: "'Noto Sans JP', sans-serif" }}>
                代表取締役　山中 美樹
              </p>
            </div>
            <img
              src={presidentPortrait}
              alt=""
              className="h-14 w-14 shrink-0 rounded-full object-cover object-top opacity-90 ring-1 ring-[rgba(168,205,217,0.45)] sm:h-16 sm:w-16"
              width={64}
              height={64}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
